import { query } from "@lookiero/messaging";
const VIEW_UI_SETTING_BY_KEY = "view_ui_setting_by_key";
const viewUiSettingByKey = (payload) => ({
    ...query({ name: VIEW_UI_SETTING_BY_KEY }),
    ...payload,
});
const viewUiSettingByKeyHandler = ({ view }) => async ({ key }) => view({ key });
export { VIEW_UI_SETTING_BY_KEY, viewUiSettingByKey, viewUiSettingByKeyHandler };
